import type { EmailTone, SendEmailStatus } from './enums';
import type { TemplateLanguage } from '../customEmailTemplate';

/** Outlook cuts a longer subject. The server applies the same limit to a custom template's subject. */
export const EMAIL_SUBJECT_MAX_LENGTH = 255;

export interface AttachmentDto {
  filePathName: string;
  fileType: string;
  uploaded: boolean | null;
}

export interface RelanceEmailDto {
  subject: string;
  recipientEmail: string;
  selectedTone: EmailTone;
  bodyTone: string;
  attachments: AttachmentDto[] | null;
  ccEmail?: string | null;
  bccEmail?: string | null;
  /** Set when the body is the company's custom template, its macros still in canonical `{{name}}` form. */
  customTemplateLanguage?: TemplateLanguage | null;
}

export interface SendEmailRequest {
  draftId: string | null;
  draft: RelanceEmailDto | null;
  autoAttachmentIds: string[] | null;
  /**
   * Whether the reminder carries its Transphere payment links. Only the flag travels — never the
   * URLs: the server composes the block from the links it resolved, so a link assembled here could
   * not be verified as one of ours. Omitted means true.
   */
  includePaymentLinks?: boolean;
  /**
   * Product-analytics signals about the draft, reported because only this side still holds the
   * comparison: it loaded what the AI wrote and watched the user work on it. Nothing about the send
   * depends on them, and omitting them simply leaves the signal unknown.
   */
  draftEdited?: boolean;
  aiSelectedTone?: EmailTone;
}

export interface SendEmailResponse {
  messageId: string;
  status: SendEmailStatus;
  errors: string[] | null;
  failedAutoAttachmentFileNames: string[] | null;
}
